import { COMPLIANCE_PACK_STATUSES, type CatalogueStatus } from "../types";
import type { StatusPillTone } from "../design/StatusPill";
import { toCatalogueStatusPillMapping } from "../design/catalogueStatusPill";

/**
 * Choices for the shared two-state catalogue status ('pendiente' | 'validado').
 * SelectInput/SelectField translate a choice's `name` as a message key by
 * default, so these keys must exist in every locale's crm messages file.
 */
export const COMPLIANCE_PACK_STATUS_CHOICES: Array<{
  id: CatalogueStatus;
  name: string;
}> = COMPLIANCE_PACK_STATUSES.map((status) => ({
  id: status,
  name: `resources.projects.compliance_pack_status.${status}`,
}));

/**
 * Maps a project's `compliance_pack_status` to a StatusPill tone plus the
 * i18n message key to translate (Almikia design-system.md section 3: the
 * two-state catalogue renders as a green/red StatusPill). Kept pure (no
 * `useTranslate`) so it stays trivially unit-testable
 * (complianceStatus.test.ts); an unexpected value returns `messageKey: null`
 * and the "not-ok" tone -- see {@link ComplianceStatusPill}, which then
 * falls back to the raw value instead of crashing on a missing key.
 */
export function complianceStatusToPill(status: unknown): {
  tone: StatusPillTone;
  messageKey: string | null;
} {
  const { tone, labelKey } = toCatalogueStatusPillMapping(status);
  return {
    tone,
    messageKey: labelKey
      ? `resources.projects.compliance_pack_status.${labelKey}`
      : null,
  };
}
